export default "__VITE_ASSET__CiVpQR01__"